var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7182 4.57823C20.6139 -1.52608 10.7142 -1.52608 4.57823 4.57823C-1.52608 10.6825 -1.52608 20.5823 4.57823 26.7182C10.6825 32.8225 20.5823 32.8225 26.7182 26.7182C32.8225 20.6139 32.8225 10.7142 26.7182 4.57823ZM21.8474 16.4389C21.8158 16.4389 21.8158 16.4389 21.8474 16.4389H12.9282C13.4342 17.1348 13.7189 17.9571 13.7189 18.8743C13.7189 21.2148 11.8212 23.0809 9.51228 23.0809C7.17177 23.0809 5.27406 21.1832 5.27406 18.8743C5.27406 16.6287 7.04526 14.7942 9.25925 14.6677H18.4315C17.9255 13.9719 17.6408 13.1496 17.6408 12.2323C17.6408 9.89182 19.5385 8.02574 21.8474 8.02574C24.1879 8.02574 26.054 9.92345 26.054 12.2323C26.054 14.5412 24.1563 16.4389 21.8474 16.4389Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.fc655279f2ec2978183c9ab91b0a8687.svg";
export { ForwardRef as ReactComponent };